module.exports = __webpack_public_path__ + "static/img/80-1.5f5c3ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/80-1.jpg
// module id = jNfw
// module chunks = 0